export const DEFAULT_TAX_RATE = 8.1;
